<template>
    <div>
        <!-- [formrun] class, action, methodの変更不可 -->
        <form id="formrun" class="formrun" :action="formrunSubmitUrl" method="post">
            <input v-model="email" name="_field_1" data-disp-name="メールアドレス" type="text" data-formrun-type="email">
            <input v-model="fullName" name="_field_2" data-disp-name="氏名" type="text">
            <input v-model="fullName" name="_field_5" data-disp-name="氏名" type="text">
            <input v-model="fullNameKana" name="_field_7" data-disp-name="フリガナ" type="text">
            <input v-model="utmContent" name="_field_33" data-disp-name="現在の居住区" type="text">
            <input value="同意する" name="_field_15" data-disp-name="利用規約に同意する" type="text">
            <input value="同意する"  name="_field_14" data-disp-name="プライバシーポリシーに同意する" type="text">

            <input v-model="userAgent" name="_field_40" data-disp-name="ユーザーエージェント" type="text">
            <input v-model="device" name="_field_41" data-disp-name="端末" type="text">
            <input v-model="source" name="_field_44" data-disp-name="参照元" type="text">

            <input v-model="user.last_name" name="lastName" data-disp-name="姓" type="text">
            <input v-model="user.first_name" name="firstName" data-disp-name="名" type="text">

            <input v-model="user.last_name" name="_field_13_last_name" data-disp-name="姓" type="text">
            <input v-model="user.first_name" name="_field_13_first_name" data-disp-name="名" type="text">

            <!-- ボット投稿をブロックするためのタグ -->
            <div class="_formrun_gotcha">
                <label for="_formrun_gotcha">If you are a human, ignore this field</label>
                <input type="text" name="_formrun_gotcha" id="_formrun_gotcha" tabindex="-1">
            </div>
        </form>

        <div
            v-if="isSubmit === '1'"
            class="spinnerWrapper d-flex justify-content-center align-items-center">
            <b-spinner variant="yokumiru-user"/>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        props: {
            user: {
                type: Object,
                required: true,
            },
            email: {
                type: String,
                required: true,
            },
            utmContent: {
                type: String,
                default: '',
            },
            source: {
                type: String,
                default: '',
            },
            formrunUid: {
                type: String,
                required: true,
            },
            isSubmit: {
                type: String,
                default: '0',
            },
            redirectMessage: {
                type: String|null,
                default: null,
            },
            redirectMessageType: {
                type: String|null,
                default: null,
            },
        },

        data: function() {
            return {
                inProgress: false,
                errors: {},
            };
        },

        computed: {
            userAgent: function () {
                return window.navigator.userAgent.toLowerCase()
            },

            device: function () {
                const ua = this.userAgent

                if (ua.indexOf("windows nt") !== -1) {
                    return 'Microsoft Windows'
                }
                else if (ua.indexOf("android") !== -1) {
                    if (ua.indexOf('mobile') !== -1) {
                        return 'android smartphone'
                    }
                    else {
                        return 'android Tablet'
                    }
                }
                else if (ua.indexOf('iphone') !== -1) {
                    return 'iPhone'
                }
                else if (ua.indexOf('ipad') !== -1) {
                    return 'iPad'
                }
                else if (ua.indexOf("mac os x") !== -1) {
                    return 'macOS'
                }
                else {
                    return 'その他'
                }
            },

            fullName: function () {
                if (this.user.last_name && this.user.first_name) {
                    return `${this.user.last_name} ${this.user.first_name}`
                }
                return ''
            },

            fullNameKana: function () {
                if (this.user.last_name_kana && this.user.first_name_kana) {
                    return `${this.user.last_name_kana} ${this.user.first_name_kana}`
                }
                return ''
            },

            formrunSubmitUrl: function () {
                return `https://form.run/api/v1/r/${this.formrunUid}`
            },
        },

        created: function () {
            if (this.redirectMessage && this.redirectMessageType) {
                this.setRedirectMessage(this.redirectMessage)
                this.setRedirectMessageType(this.redirectMessageType)
            }
            bus.$on('formrun-submit-required', this.submit)
        },

        beforeDestroy: function () {
            bus.$off('formrun-submit-required')
        },

        mounted: function () {
            if (this.isSubmit === '1') {
                // submit完了後はformrun側に設定されている「リダイレクト先URL」へ飛ぶ（例: https://localhost:8000/register/complete）
                this.submit()
            }
        },

        methods: {
            ...mapMutations({
                setRedirectMessage: 'userMode/setRedirectMessage',
                setRedirectMessageType: 'userMode/setRedirectMessageType',
            }),

            submit: async function () {
                document.querySelector('#formrun').submit()
            },
        },
    }
</script>

<style lang="scss" scoped>
#formrun {
    position: absolute;
    left: -9999px;
    top: -9999px;
    z-index: -1;
}

._formrun_gotcha {
    height:1px;
    width:1px;
    overflow:hidden;
}

.spinnerWrapper {
    width: 100vw;
    height: calc(100vh - 100px);
}
</style>
